import * as Yup from 'yup';

import {
  representativeRequirementOf,
  representedOrganizationOf,
} from '../utils/representation-requirements.util';
import type {
  RepresentationReferences,
  RepresentationRules,
  RepresentedOrganization,
} from '../utils/representation-requirements.util';

// An organization of the group (the recharged internal included) has at least
// one representative; an external organization only when a rule of the
// workflow asks for it.
export const representativesSelectSchemaOf = (
  rules: RepresentationRules,
  references: RepresentationReferences,
) =>
  Yup.object().shape({
    representatives: Yup.array().test(
      'represented',
      ({ path }) => path,
      function isRepresented(representatives) {
        const requirement = representativeRequirementOf(
          representedOrganizationOf(
            this.parent as Partial<RepresentedOrganization>,
          ),
          rules,
          references,
        );

        return !requirement || !!representatives?.length
          ? true
          : this.createError({ message: requirement });
      },
    ),
  });
